import { gql, useLazyQuery } from '@moonpig/web-core-graphql'
import { isLoggedIn } from '@moonpig/web-core-auth'
import { getBrowserCookies } from '@moonpig/web-core-browser-storage'
import { logger } from '@moonpig/web-core-monitoring'
import {
  GetCustomerIDQuery,
  GetCustomerIDQueryVariables,
} from './__generated__/useGetCustomerId'

export const GetCustomerIDGQL = gql`
  query GetCustomerIDQuery($isAuthenticated: Boolean!) {
    me @include(if: $isAuthenticated) {
      customer {
        id
      }
    }
  }
`

export const useGetCustomerId = () => {
  const cookies = getBrowserCookies()
  const isAuthenticated = isLoggedIn(cookies)

  const [getCustomerId, { error }] = useLazyQuery<
    GetCustomerIDQuery,
    GetCustomerIDQueryVariables
  >(GetCustomerIDGQL, { variables: { isAuthenticated }, ssr: false })

  if (error) {
    logger.fixImmediately(
      `Error fetching customer ID in ${__filename}: ${error.message}`,
    )
  }

  return { getCustomerId }
}
